import { memo } from 'react';
import Pressable from "../../../other/Pressable";

const BotoImportar = memo(({ setImporting, disabled }) => {
    const importar = () => {
        setImporting(true)
    }

    return (
        <Pressable onClick={importar} id="importar-container" style={{ backgroundColor: 'rgba(0, 0, 255, 0.2)' }} className={`boto boto-save ${disabled ? 'disabled' : ''}`}>
            📥
        </Pressable>
    );
});

export default BotoImportar;